var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0828B7",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_331_4634",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_331_4634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 35C22.1333 35 20.4167 34.575 18.85 33.725C17.2833 32.875 16 31.7417 15 30.325V33H13V27H19V29H16.525C17.325 30.2 18.3792 31.1667 19.6875 31.9C20.9958 32.6333 22.4333 33 24 33C25.25 33 26.4208 32.7625 27.5125 32.2875C28.6042 31.8125 29.5542 31.1708 30.3625 30.3625C31.1708 29.5542 31.8125 28.6042 32.2875 27.5125C32.7625 26.4208 33 25.25 33 24H35C35 25.5167 34.7125 26.9417 34.1375 28.275C33.5625 29.6083 32.775 30.775 31.775 31.775C30.775 32.775 29.6083 33.5625 28.275 34.1375C26.9417 34.7125 25.5167 35 24 35ZM23.1 31V29.7C22.3167 29.5167 21.6792 29.1792 21.1875 28.6875C20.6958 28.1958 20.3333 27.55 20.1 26.75L21.75 26.1C21.95 26.7833 22.2625 27.2958 22.6875 27.6375C23.1125 27.9792 23.6 28.15 24.15 28.15C24.7 28.15 25.1708 28.0208 25.5625 27.7625C25.9542 27.5042 26.15 27.1 26.15 26.55C26.15 26.0667 25.9458 25.675 25.5375 25.375C25.1292 25.075 24.4 24.7333 23.35 24.35C22.3667 24 21.6458 23.5833 21.1875 23.1C20.7292 22.6167 20.5 21.9833 20.5 21.2C20.5 20.5167 20.7375 19.8958 21.2125 19.3375C21.6875 18.7792 22.3333 18.4167 23.15 18.25V17H24.9V18.25C25.5 18.3 26.0458 18.5417 26.5375 18.975C27.0292 19.4083 27.3667 19.9167 27.55 20.5L25.95 21.15C25.8167 20.7667 25.6 20.4458 25.3 20.1875C25 19.9292 24.5833 19.8 24.05 19.8C23.4667 19.8 23.0208 19.925 22.7125 20.175C22.4042 20.425 22.25 20.7667 22.25 21.2C22.25 21.6333 22.4417 21.975 22.825 22.225C23.2083 22.475 23.9 22.7667 24.9 23.1C26.1 23.5333 26.9 24.0417 27.3 24.625C27.7 25.2083 27.9 25.85 27.9 26.55C27.9 27.0333 27.8167 27.4583 27.65 27.825C27.4833 28.1917 27.2625 28.5042 26.9875 28.7625C26.7125 29.0208 26.3917 29.2292 26.025 29.3875C25.6583 29.5458 25.2667 29.6667 24.85 29.75V31H23.1ZM13 24C13 22.4833 13.2875 21.0583 13.8625 19.725C14.4375 18.3917 15.225 17.225 16.225 16.225C17.225 15.225 18.3917 14.4375 19.725 13.8625C21.0583 13.2875 22.4833 13 24 13C25.8667 13 27.5833 13.425 29.15 14.275C30.7167 15.125 32 16.2583 33 17.675V15H35V21H29V19H31.475C30.675 17.8 29.6208 16.8333 28.3125 16.1C27.0042 15.3667 25.5667 15 24 15C22.75 15 21.5792 15.2375 20.4875 15.7125C19.3958 16.1875 18.4458 16.8292 17.6375 17.6375C16.8292 18.4458 16.1875 19.3958 15.7125 20.4875C15.2375 21.5792 15 22.75 15 24H13Z",
    fill: "#0828B7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/Dollar.f5a8c015e8b2cf0a5d1468eb7be71ca2.svg";
export { ForwardRef as ReactComponent };